import { render, staticRenderFns } from "./PaymentTypeTable.vue?vue&type=template&id=288f64b4"
import script from "./PaymentTypeTable.vue?vue&type=script&lang=js"
export * from "./PaymentTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports